export const model = {
  password: '',
  passwordCheck: ''
};